<script>
import Loading from './Loading'

export default {
  Loading
}
</script>



// WEBPACK FOOTER //
// index.vue?e01e62fc